import Layout from '@layout/Index'

export const platformUserWhitelist = [
  {
    path: '/platform-user-whitelist',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "platform-user-whitelist-table" */ './pages/PlatformUserWhitelistTable.vue'),
        name: '发布白名单用户列表',
        meta: {
          title: '发布白名单用户列表',
        },
      },
      {
        path: 'add/form',
        component: () => import(/* webpackChunkName: "platform-user-whitelist-form" */ './pages/PlatformUserWhitelistAddForm.vue'),
        name: '添加发布白名单用户',
        meta: {
          title: '添加发布白名单用户',
        },
      },
      {
        path: 'delete/:form',
        component: () => import(/* webpackChunkName: "platform-user-whitelist-form" */ './pages/PlatformUserWhitelistDeleteForm.vue'),
        name: '删除发布白名单用户',
        meta: {
          title: '删除发布白名单用户',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/platform-user-whitelist/platform-user-whitelist.route.js